import CityHandler from "./cityHandler.service";

const cityHandlerModule = angular
  .module("app.services.cityHandler", [])
  .service("CityHandler", CityHandler);

export default cityHandlerModule;



// WEBPACK FOOTER //
// ./src/services/cityHandler/cityHandler.module.js